import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SELECT_EXPORT_PAGES } from "@/Constants/common";
import {
  deSelectAllCandidate,
  fetchBookedCandidates,
  setBookedCandidatesLoading,
  updatePagination,
  updateCandidateStatus,
  updateBookedMergeContracts,
} from "@/reducers/client_candidates/candidatesbooked";
import { toggleOurServiceModal } from "@/reducers/clientcommon";
import { toastMessageText } from "@/utilities/CommonText";
import { showCommonToast } from "@/utilities/utils";

import { fetchCandidateTypes } from "../../../../../../reducers/clientdashboard";
import { _exportBookedCandidates } from "../../../../../../services/clientexport";
import ExportButton from "../../../ActionButtons/ExportButton";
import MarkAsPreferredButton from "../../../ActionButtons/MarkAsPreferredButton";
import { MarkAsUnsuitableButton } from "../../../ActionButtons/MarkAsUnsuitableButton";
import { RemoveStatusButton } from "../../../ActionButtons/RemoveStatusButton";

/**
 * Function to handle shortlisting of candidates.
 *
 * @param {object} data - The data containing candidate ids to be shortlisted
 * @return {void} This function does not return anything
 */
export const Actions = () => {
  const dispatch = useDispatch();
  const {
    selectedCandidate,
    filters,
    pagination,
    isSelectedAll,
    selectedContract,
    bookedCandidates,
    listView,
  } = useSelector((state) => state.clientCandidatesBooked);
  const { clientUserAllPermissions, isPremiumAccount } = useSelector(
    (state) => state.session,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const [shortListLoading, setShortListLoading] = useState(false);
  const [unsuitableLoading, setUnsuitableLoading] = useState(false);
  const [removeStatusLoading, setRemoveStatusLoading] = useState(false);
  const [mergeContractLoading, setMergeContractLoading] = useState(false);

  /**
   * Function to handle reloading the table.
   */
  const handleReloadTable = (
    unsuitable,
    sortlisted,
    isSelectedAll,
    ignoreIds,
    ids,
  ) => {
    dispatch(
      updateCandidateStatus({
        unsuitable,
        sortlisted,
        isSelectedAll,
        ignoreIds,
        ids,
      }),
    );
    dispatch(deSelectAllCandidate());
  };

  const refreshTable = () => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setBookedCandidatesLoading(true));
    dispatch(fetchCandidateTypes());
    dispatch(fetchBookedCandidates(filters));
    dispatch(
      fetchCandidateTypes({
        bookedView: listView,
      }),
    );
  };

  const checkSelectedIDsAndRolesForMerge = () => {
    // Filter the bookedCandidates that match the selected contract IDs
    const selectedCandidates = bookedCandidates.filter((candidate) =>
      selectedContract.includes(candidate.contract_id),
    );

    // Check if all role_name are the same
    const allRolesSame = selectedCandidates.every(
      (candidate) => candidate.role_name === selectedCandidates[0].role_name,
    );

    // Check if all candidate_id are the same
    const allCandidateIDsSame = selectedCandidates.every(
      (candidate) =>
        candidate.candidate_id === selectedCandidates[0].candidate_id,
    );

    // Return true if both conditions are satisfied
    return allRolesSame && allCandidateIDsSame;
  };

  const handleToMergeContracts = (e) => {
    if (!isPremiumAccount) {
      e.preventDefault();
      dispatch(toggleOurServiceModal(true)); // Show modal if not premium
      return;
    }

    if (selectedContract.length) {
      if (selectedContract.length === 1) {
        // If only one contract is selected, show an error
        showCommonToast(toastMessageText?.otherContractToMerge, {
          id: "single-merge-selected",
        });
      } else if (selectedContract.length > 5) {
        // If more than 5 contracts are selected, show an error
        showCommonToast(toastMessageText.selectUpToFiveContractToMerge, {
          id: "max-merge-limit",
        });
      } else {
        // If between 2 and 5 contracts are selected
        if (checkSelectedIDsAndRolesForMerge()) {
          // All selected contracts are valid for merging
          dispatch(
            updateBookedMergeContracts({
              contract_ids: selectedContract.join(","),
              callback: refreshTable,
              loading: mergeContractLoading,
              setLoading: setMergeContractLoading,
            }),
          );
        } else {
          // Selected contracts don't match in candidate_id or role_name
          showCommonToast(toastMessageText?.validContractToMegerdOrNot, {
            id: "invalid-merge-selection",
          });
        }
      }
    } else {
      // No contract is selected
      showCommonToast(toastMessageText?.selectOneContractToMerge, {
        id: "no-merge-selected",
      });
    }

    // dispatch(updateBookedMergeContracts({
    //   contract_ids: [selectedContract, selectedMergeContract].join(","),
    //   callback,
    //   loading: mergeContractLoading,
    //   setLoading: setMergeContractLoading
    // }))

    // if (selectedContract.length) {
    //   if (selectedContract.length === 1) {
    //     dispatch(
    //       fetchBookedMergeContractShifts({
    //         contractId: selectedContract,
    //         loading: mergeContractLoading,
    //         setLoading: setMergeContractLoading,
    //       }),
    //     );
    //   } else {
    //     showCommonToast(
    //       "Please select one candidate to merge contract",
    //       {
    //         id: "no-merge-selected",
    //       },
    //     );
    //   }
    // } else {
    //   e.preventDefault();
    //   showCommonToast(
    //     "Please select one candidate to merge contract",
    //     {
    //       id: "no-merge-selected",
    //     },
    //   );
    // }
  };

  return (
    <div className="Actions_Wrapper tour-booked-actions">
      <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
        <MarkAsPreferredButton
          selectedCandidate={selectedCandidate}
          loading={shortListLoading}
          setLoading={setShortListLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.BOOKED}
          isSelectedAll={isSelectedAll}
          ignoreIds={
            isSelectedAll
              ? bookedCandidates
                  .filter((ele) => !selectedContract.includes(ele.contract_id))
                  .map((ele) => ele.candidate_id)
                  .join(", ")
              : ""
          }
          callback={handleReloadTable}
        />
        <RemoveStatusButton
          selectedCandidate={selectedCandidate}
          loading={removeStatusLoading}
          setLoading={setRemoveStatusLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.BOOKED}
          isSelectedAll={isSelectedAll}
          ignoreIds={
            isSelectedAll
              ? bookedCandidates
                  .filter((ele) => !selectedContract.includes(ele.contract_id))
                  .map((ele) => ele.candidate_id)
                  .join(",")
              : ""
          }
          callback={handleReloadTable}
        />
        <MarkAsUnsuitableButton
          selectedCandidate={selectedCandidate}
          loading={unsuitableLoading}
          setLoading={setUnsuitableLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.BOOKED}
          isSelectedAll={isSelectedAll}
          ignoreIds={
            isSelectedAll
              ? bookedCandidates
                  .filter((ele) => !selectedContract.includes(ele.contract_id))
                  .map((ele) => ele.candidate_id)
                  .join(",")
              : ""
          }
          callback={handleReloadTable}
        />

        {/* <MergeContractModal callback={refreshTable} /> */}

        {/* {!clientUserAllPermissions ||
          clientUserAllPermissions.is_allow_to_merge_contract === 1 ? (
          listView !== "shifts" ? (
            <Tooltip title={TOOLTIPTEXT.mergeContract}>
              <div
                className={`${ACTION_BTN_HOVER_CLR.green} ${isPremiumAccount ? "${ACTION_BTN_HOVER_CLR.green} group" : "cursor-not-allowed opacity-50"}`}
                onClick={handleToMergeContracts}
              >
                <ActionIcons
                  isLoading={mergeContractLoading}
                  type={"mergeContract"}
                />
              </div>
            </Tooltip>
          ) : null
        ) : null} */}

        <ExportButton
          page={SELECT_EXPORT_PAGES.BOOKED}
          isPrimary={true}
          exportFunction={_exportBookedCandidates}
          selectedTablesData={selectedCandidate}
          ignoreIds={
            isSelectedAll
              ? bookedCandidates
                  .filter((ele) => !selectedContract.includes(ele.contract_id))
                  .map((ele) => ele.contract_id)
                  .join(",")
              : ""
          }
          isSelectedAll={isSelectedAll}
          extraObj={{
            contract_ids: selectedContract.join(","),
          }}
          emptyExportMessage={toastMessageText.emptyExportMessageForContract}
        />
      </div>
    </div>
  );
};
